module.exports = __webpack_public_path__ + "static/media/wujinBackground.be9c1d51.jpg";